import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "https://api-dev2.materialdepot.in/apiV1";
const refreshClient = axios.create({ baseURL });

// Single-flight refresh shared across every axios client so a burst of 401s
// triggers exactly one token/refresh/ call.
let refreshPromise: Promise<string | null> | null = null;

export function refreshAccessToken(): Promise<string | null> {
  const refresh = localStorage.getItem("refresh");
  if (!refresh) return Promise.resolve(null);
  if (!refreshPromise) {
    refreshPromise = refreshClient
      .post("/token/refresh/", { refresh })
      .then((r) => {
        const access = r.data?.access;
        if (!access) return null;
        localStorage.setItem("token", access);
        if (r.data.refresh) localStorage.setItem("refresh", r.data.refresh);
        return access;
      })
      .catch(() => null)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

export function attachAuthRefresh(client: any) {
  client.interceptors.response.use(undefined, async (error: any) => {
    const status = error.response?.status;
    const original = error.config;
    if ((status === 401 || status === 403) && original && !original._retried) {
      original._retried = true;
      const access = await refreshAccessToken();
      if (access) {
        original.headers = { ...original.headers, Authorization: `JWT ${access}` };
        return client(original);
      }
      window.location.replace("/login");
    }
    return Promise.reject(error);
  });
}
